import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=a80e67ba&scoped=true&"
import script from "./BottomNavigation.vue?vue&type=script&lang=js&"
export * from "./BottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=a80e67ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80e67ba",
  null
  
)

export default component.exports